module.exports = __webpack_public_path__ + "images/5b5b515941487c75783cdc5f6ce6a237-logo_caymankind.png";